
/**
 * Recursively removes keys with `undefined` values from an object or array.
 * Firestore throws an error if `undefined` is passed to update/set.
 * Note: `null` is allowed and preserved.
 */
export function stripUndefinedDeep<T>(obj: T): T {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (obj instanceof Date) {
    return obj as any;
  }

  if (Array.isArray(obj)) {
    // Filter out undefined items from arrays, map the rest
    return obj
      .filter((item) => item !== undefined)
      .map((item) => stripUndefinedDeep(item)) as any;
  }

  const out: any = {};
  for (const [k, v] of Object.entries(obj as any)) {
    if (v !== undefined) {
      out[k] = stripUndefinedDeep(v);
    }
  }
  return out;
}
